import React from 'react';
import PropTypes from 'prop-types';

const CourseLabel = props => {
  return (
    <div className="course-label">
      <div className="course-label-line" />
      <div className="is-flex align-items-center">
        <img src={props.icon} />
        <p className="course-label-text">{props.text}</p>
      </div>
    </div>
  );
};

CourseLabel.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default CourseLabel;
